var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_wallet",
    "data-name": "vuesax/bulk/wallet",
    transform: "translate(-108 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.7.518l-.03.07-2.9,6.73H1.92A4.777,4.777,0,0,0,0,7.708l1.75-4.18.04-.09.06-.16a1.586,1.586,0,0,1,.08-.18C3.24.068,4.72-.622,7.7.518Z",
    transform: "translate(113.2 510.002)",
    fill: "#020d88",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.32,7a5.057,5.057,0,0,0-1.41-.2H0L2.9.07,2.93,0c.14.05.29.12.44.17l2.21.93A6.617,6.617,0,0,1,8.2,2.78c.09.12.17.23.25.36a1.522,1.522,0,0,1,.2.43,1.338,1.338,0,0,1,.09.26A4.826,4.826,0,0,1,8.32,7Z",
    transform: "translate(117.97 510.52)",
    fill: "#020d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M19.52,4.88V6.83c0,.2-.01.4-.02.59-.19,3.5-2.14,5.26-5.84,5.26H5.86a5.394,5.394,0,0,1-.71-.05Q.38,12.315.05,7.54A5.648,5.648,0,0,1,0,6.83V4.88A4.894,4.894,0,0,1,2.96.39,4.777,4.777,0,0,1,4.88,0h9.76a5.057,5.057,0,0,1,1.41.2A4.9,4.9,0,0,1,19.52,4.88Z",
    transform: "translate(110.24 517.32)",
    fill: "#020d88",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.71,0,2.96,4.18A4.894,4.894,0,0,0,0,8.67V5.74A5.849,5.849,0,0,1,4.71,0Z",
    transform: "translate(110.24 513.53)",
    fill: "#020d88",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3.47,5.18V8.11A4.9,4.9,0,0,0,0,3.43,4.826,4.826,0,0,0,.42.26,1.338,1.338,0,0,0,.33,0,5.84,5.84,0,0,1,3.47,5.18Z",
    transform: "translate(126.29 514.09)",
    fill: "#020d88",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 508)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.67d6f394dff4209e57178ee652fe358e.svg";
export { ForwardRef as ReactComponent };